import { Injectable } from '@angular/core'
import { Response, RequestOptionsArgs } from '@angular/http'
import { Observable } from 'rxjs/Observable'

@Injectable()
export abstract class IAppHttp {
  abstract get(url: string, options?: RequestOptionsArgs): Observable<Response>

  abstract post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response>

  abstract patch(url: string, body: string, options?: RequestOptionsArgs): Observable<Response>

  abstract delete(url: string, options?: RequestOptionsArgs): Observable<Response>
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/http/i-app-http.ts